import { buildAction } from 'store/actions/actionCreator'

import {
  CLOSE_CHANNEL_DETAILS,
  FETCH_CLOSED_REPORTING_ONLY_STORES,
  HIDE_DETAILS,
  OPEN_DETAILS,
  SET_SELECTED_VALUE,
  SHOW_CHANNEL_DETAILS,
} from './constants'

export const fetchClosedReportingOnlyStores = buildAction(FETCH_CLOSED_REPORTING_ONLY_STORES)

export const hideDetails = buildAction(HIDE_DETAILS)
export const openDetails = buildAction(OPEN_DETAILS, 'payload')

export const closeChannelDetails = buildAction(CLOSE_CHANNEL_DETAILS)
export const showChannelDetails = buildAction(SHOW_CHANNEL_DETAILS, 'countryId', 'countryNamePL')

export const setSelectedValue = buildAction(SET_SELECTED_VALUE, 'value')
